// LogisticsScheduleManager.jsx
import React, { useState, useEffect } from 'react';
import { Truck, Package, Clock, Plus, Calendar, ChevronLeft, ChevronRight, Search } from 'lucide-react';
import './movimientosVip.css';
import Crud_Catalogos from '../../herramientas/Crud_Catalogos'
import { NotificationManager } from 'react-notifications';
import { Dimmer } from 'tabler-react';

const RegistroHorarios = () => {

  const tipoMovImpo = 568;
  const tipoMovExpo = 567; 
  const [services, setServices] = useState([]);
  const [activeTab, setActiveTab] = useState('importacion');
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedService, setSelectedService] = useState(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleDateTime, setScheduleDateTime] = useState('');
  const [movTipo,setMovTipo] = useState(tipoMovImpo);
  const [logisticFields, setLogisticFields] = useState([]);
  const [scheduleValues, setScheduleValues] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  const servicesPerPage = 6;

  const user = JSON.parse(sessionStorage.getItem("usuario"));

  const plataforma = JSON.parse(sessionStorage.getItem("plataforma"));

  // Convertir de "YYYY-MM-DD HH:MM:SS" a "YYYY-MM-DDTHH:MM" para input datetime-local
  const formatToDatetimeLocal = (dateStr) => {
    if (!dateStr) return '';
    return dateStr.replace(' ', 'T').substring(0, 16);
  };

  // Convertir de "YYYY-MM-DDTHH:MM" a "YYYY-MM-DD HH:MM:SS" para la API
  const formatToAPI = (dateStr) => {
    if (!dateStr) return '';
    return dateStr.replace('T', ' ') + ':00';
  };

  useEffect(() => {
    loadLogisticFields();
  }, []);

  useEffect(() => {
    loadServices();
  }, [movTipo, currentPage, searchTerm]);

  const loadLogisticFields = async () => {
    const idPlataforma = plataforma?.id;
    if (!idPlataforma) return;

    Crud_Catalogos("variables/" + idPlataforma, "", "get", "", [], "", "", "", [])
    .then((variables) => {
      const datetimeFields = variables.filter(v => v.tipo === 'DateTime');
      setLogisticFields(datetimeFields);
    }).catch(err => {
      console.error('Error cargando variables:', err);
    });
  };

  const loadServices = async () => {
    setIsLoading(true);

    const pageNumber = Number(currentPage) || 1;
    let url = "navieraMovimientosPerfil/usuario_transportista/" + user.id + "/movTipo/" + movTipo + 
              "?page=" + (pageNumber - 1) + "&size=" + servicesPerPage + "";
    
    if (searchTerm && searchTerm.trim() !== '') {
      const term = encodeURIComponent(searchTerm.trim());
      url += "&po=" + term + "&contenedor=" + term + "&booking=" + term;
    }

    Crud_Catalogos(url, "", "get", "", [], "", "", "", [])
    .then((returnVal) => {
      const mappedServices = returnVal.content.map(mov => {
        let variablesObj = {};
        try {
          variablesObj = mov.variables ? JSON.parse(mov.variables) : {};
        } catch (e) {
          console.error('Error parseando variables:', e);
        }

        return {
          ...mov,
          variablesData: variablesObj
        };
      });

      setServices(mappedServices);
      setTotalPages(returnVal.totalPages);
      setIsLoading(false);
    }).catch(err => {
      console.error('Error cargando servicios:', err);
      setIsLoading(false);
    });
  };

  const handleScheduleService = (service) => {
    setSelectedService(service);
    
    const variablesObj = service.variablesData || {};

    const initialValues = {};
    logisticFields.forEach(field => {
      const value = variablesObj[field.nombre];
      initialValues[field.nombre] = value ? formatToDatetimeLocal(value) : '';
    });
    setScheduleValues(initialValues);
    setShowScheduleModal(true);
  };

  const saveSchedule = () => {
    const hasValues = Object.values(scheduleValues).some(v => v && v.trim() !== '');
    
    if (!hasValues) {
      NotificationManager.warning('Por favor ingresa al menos un horario', 'Validación');
      return;
    }

    setIsSaving(true);

    // Parsear el campo variables existente
    let variablesObj = {};
    try {
      variablesObj = selectedService.variables ? JSON.parse(selectedService.variables) : {};
    } catch (e) {
      console.error('Error parseando variables:', e);
    }

    // Actualizar variables con los nuevos horarios en formato API
    logisticFields.forEach(field => {
      if (scheduleValues[field.nombre]) {
        variablesObj[field.nombre] = formatToAPI(scheduleValues[field.nombre]);
      }
    });

    // Crear objeto limpio solo con los campos necesarios del movimiento original
    const updateData = {
      id: selectedService.id,
      idOtd: selectedService.idOtd,
      idNaviera: selectedService.idNaviera,
      idClienteNaviero: selectedService.idClienteNaviero,
      idPlataforma: selectedService.idPlataforma,
      idOperacionTipo: selectedService.idOperacionTipo,
      idOperacionEstatus: selectedService.idOperacionEstatus,
      idRuta: selectedService.idRuta,
      idMovimientoTipo: selectedService.idMovimientoTipo,
      idTransportista: selectedService.idTransportista,
      idTransportista2: selectedService.idTransportista2,
      idCorredor: selectedService.idCorredor,
      idLocalidad: selectedService.idLocalidad,
      idCliente: selectedService.idCliente,
      contenedorTipo: selectedService.contenedorTipo,
      contenedorSize: selectedService.contenedorSize,
      destino: selectedService.destino,
      nota: selectedService.nota,
      empacador: selectedService.empacador,
      booking: selectedService.booking,
      po: selectedService.po,
      contenedor: selectedService.contenedor,
      sello: selectedService.sello,
      variables: JSON.stringify(variablesObj)
    };

    // Llamar a la API
    Crud_Catalogos(
      "navieraMovimientos/updateFechas/" + selectedService.id,
      "",
      "put",
      "",
      updateData,
      "",
      "",
      "",
      []
    )
    .then(() => {
      NotificationManager.success('Horarios logísticos guardados exitosamente', 'Guardado');
      setIsSaving(false);
      setShowScheduleModal(false);
      setSelectedService(null);
      setScheduleValues({});
      loadServices();
    })
    .catch(err => {
      console.error('Error guardando horarios:', err);
      NotificationManager.error('Error al guardar los horarios', 'Error');
      setIsSaving(false);
    });
  };

  const getStatusBadge = (service) => {
    const variablesObj = service.variablesData || {};
    const allSchedulesRegistered = logisticFields.length > 0 && 
      logisticFields.every(field => variablesObj[field.nombre]);
    
    const statusConfig = {
      pending: { label: 'Pendiente', className: 'status-badge-pending' },
      ready: { label: 'Listo', className: 'status-badge-ready' },
      in_process: { label: 'En Proceso', className: 'status-badge-in-process' }
    };
    
    const status = allSchedulesRegistered ? 'ready' : 
      (service.idOperacionEstatus?.id === 1 ? 'pending' : 'in_process');
    
    const config = statusConfig[status] || statusConfig.pending;
    return <span className={`status-badge ${config.className}`}>{config.label}</span>;
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setMovTipo(tab === 'importacion' ? tipoMovImpo : tipoMovExpo);
    setCurrentPage(1);
    setSearchTerm('');
  };

  return (
    <div className="logistics-container">
      <div className="logistics-wrapper">
        {/* Header */}
        <div className="header-card">
          <div className="header-content">
            <div className="header-text">
              <h1 className="header-title">📦 Servicios Logísticos VIP</h1>
              <p className="header-subtitle">Gestión de horarios de importación y exportación</p>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs-container">
          <button
            onClick={() => handleTabChange('importacion')}
            className={`tab-button ${activeTab === 'importacion' ? 'tab-button-active tab-button-import' : ''}`}
          >
            <Package className="icon-small" />
            Importación VIP
          </button>
          <button
            onClick={() => handleTabChange('exportacion')}
            className={`tab-button ${activeTab === 'exportacion' ? 'tab-button-active tab-button-export' : ''}`}
          >
            <Truck className="icon-small" />
            Exportación VIP
          </button>
        </div>

        {/* Buscador */}
        <div className="search-card-modern">
          <div className="search-container-modern">
            <Search className="search-icon-modern" />
            <input
              type="text"
              placeholder="🔍 Buscar por PO, Contenedor o Booking..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              className="search-input-modern"
            />
          </div>
        </div>

        {/* Lista de Servicios */}
        {isLoading ? (
          <div className="services-grid">
            {[...Array(servicesPerPage)].map((_, index) => (
              <div key={index} className={`service-card service-card-${activeTab} skeleton-card`}>
                <div className="service-header">
                  <div className="service-header-left">
                    <div className="skeleton skeleton-icon"></div>
                    <div style={{ flex: 1 }}>
                      <div className="skeleton skeleton-text" style={{ width: '60%', marginBottom: '8px' }}></div>
                      <div className="skeleton skeleton-text" style={{ width: '40%' }}></div>
                    </div>
                  </div>
                  <div className="skeleton skeleton-badge"></div>
                </div>
                <div className="service-details">
                  <div className="skeleton skeleton-text" style={{ marginBottom: '8px' }}></div>
                  <div className="skeleton skeleton-text" style={{ marginBottom: '8px' }}></div>
                  <div className="skeleton skeleton-text"></div>
                </div>
                <div className="skeleton skeleton-button"></div>
              </div>
            ))}
          </div>
        ) : services.length === 0 ? (
          <div className="empty-card">
            <Package className="empty-icon" />
            <h3 className="empty-title">No se encontraron servicios</h3>
            <p className="empty-text">Intenta con otros términos de búsqueda</p>
          </div>
        ) : (
          <>
            <div className="services-grid">
              {services.map((service) => (
                <div key={service.id} className={`service-card service-card-${activeTab}`}>
                  <div className="service-header">
                    <div className="service-header-left">
                      <div className={`service-icon service-icon-${activeTab}`}>
                        {activeTab === 'importacion' ? <Package className="icon-small" /> : <Truck className="icon-small" />}
                      </div>
                      <div>
                        <h3 className="service-wo">{service.po}</h3>
                        <p className="service-client">{service.idCliente?.nombreCorto || service.idCliente?.nombre || 'Sin cliente'}</p>
                      </div>
                    </div>
                    {getStatusBadge(service)}
                  </div>

                  <div className="service-details">
                    <div className="service-detail-row">
                      <span className="detail-label">Naviera:</span>
                      <span className="detail-value">{service.idNaviera?.nombre || 'Sin naviera'}</span>
                    </div>
                    <div className="service-detail-row">
                      <span className="detail-label">Contenedor:</span>
                      <span className="detail-value">{service.contenedor || 'Sin contenedor'}</span>
                    </div>
                    <div className="service-detail-row">
                      <span className="detail-label">Fecha creación:</span>
                      <span className="detail-value">
                        {service.creationDate}
                      </span>
                    </div>
                  </div>

                  {(() => {
                    const variablesObj = service.variablesData || {};
                    const hasSchedules = logisticFields.some(field => variablesObj[field.nombre]);
                    
                    return hasSchedules ? (
                      <div className="schedule-actions">
                        <div className="schedule-assigned">
                          <div className="schedule-assigned-header">
                            <Clock className="icon-tiny" />
                            <span className="schedule-assigned-text">Horarios asignados</span>
                          </div>
                          {logisticFields.map(field => {
                            const value = variablesObj[field.nombre];
                            return value ? (
                              <p key={field.nombre} className="schedule-datetime">
                                <strong>{field.etiqueta}:</strong>{' '}
                                {new Date(value).toLocaleString('es-ES', {
                                  dateStyle: 'short',
                                  timeStyle: 'short'
                                })}
                              </p>
                            ) : null;
                          })}
                        </div>
                        <button
                          onClick={() => handleScheduleService(service)}
                          className="button-modify"
                        >
                          <Clock className="icon-tiny" />
                          Modificar Horarios
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() => handleScheduleService(service)}
                        className="button-add"
                      >
                        <Plus className="icon-tiny" />
                        Agregar Horarios
                      </button>
                    );
                  })()}
                </div>
              ))}
            </div>

            {/* Paginación */}
            <div className="pagination-card">
              <div className="pagination-info">
                Página {currentPage} de {totalPages}
              </div>
              <div className="pagination-buttons">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`pagination-nav ${currentPage === 1 ? 'pagination-nav-disabled' : ''}`}
                >
                  <ChevronLeft className="icon-small" />
                </button>
                
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (
                    page === 1 ||
                    page === totalPages ||
                    (page >= currentPage - 1 && page <= currentPage + 1)
                  ) {
                    return (
                      <button
                        key={page}
                        onClick={() => handlePageChange(page)}
                        className={`pagination-page ${currentPage === page ? 'pagination-page-active' : ''}`}
                      >
                        {page}
                      </button>
                    );
                  } else if (page === currentPage - 2 || page === currentPage + 2) {
                    return <span key={page} className="pagination-dots">...</span>;
                  }
                  return null;
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`pagination-nav ${currentPage === totalPages ? 'pagination-nav-disabled' : ''}`}
                >
                  <ChevronRight className="icon-small" />
                </button>
              </div>
            </div>
          </>
        )}

        {/* Modal */}
        {showScheduleModal && (
          <div className="modal-overlay">
            <Dimmer active={isSaving} loader>
            <div className="modal-content">
              <h2 className="modal-title">
                {selectedService?.hasSchedule ? 'Modificar' : 'Agregar'} Horario Logístico
              </h2>
              
              <div className="modal-service-info">
                <div className="modal-info-row">
                  <span className="modal-info-label">Work Order:</span>
                  <span className="modal-info-value">{selectedService?.po}</span>
                </div>
                <div className="modal-info-row">
                  <span className="modal-info-label">Cliente:</span>
                  <span className="modal-info-value">{selectedService?.idCliente?.nombreCorto || selectedService?.idCliente?.nombre}</span>
                </div>
                <div className="modal-info-row">
                  <span className="modal-info-label">Contenedor:</span>
                  <span className="modal-info-value">{selectedService?.contenedor}</span>
                </div>
              </div>

              <div className="modal-input-group">
                <label className="modal-label">
                  <Calendar className="icon-tiny inline-icon" />
                  Horarios Logísticos
                </label>
                <div className="schedule-grid">
                  {logisticFields.map(field => (
                    <div key={field.nombre} className="schedule-field">
                      <label className="schedule-field-label">
                        {field.etiqueta}
                      </label>
                      <input
                        type="datetime-local"
                        value={scheduleValues[field.nombre] || ''}
                        onChange={(e) => setScheduleValues({
                          ...scheduleValues,
                          [field.nombre]: e.target.value
                        })}
                        className="modal-input"
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="modal-actions">
                <button
                  onClick={() => {
                    setShowScheduleModal(false);
                    setSelectedService(null);
                  }}
                  className="modal-button-cancel"
                >
                  Cancelar
                </button>
                <button
                  onClick={saveSchedule}
                  className="modal-button-save"
                >
                  Guardar
                </button>
              </div>
            </div>
            </Dimmer>
          </div>
        )}
      </div>
    </div>
  );
};

export default RegistroHorarios;